import { render, staticRenderFns } from "./AccountOfferTable.vue?vue&type=template&id=b07674d6"
import script from "./AccountOfferTable.vue?vue&type=script&lang=ts"
export * from "./AccountOfferTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports